import { useSessionStore } from '@stores/sessionStore';
import { useVerificationStore } from '@stores/verificationStore';

/**
 * Open the verification modal to unlock ordering / folio on THIS device.
 *
 * Mode rule (the device-OTP endpoint requires the session to already be phone-verified):
 *  - session already verified, only this device is browse-only  → 'device'  (OTP to the room phone,
 *    sets this device's TrustedAt; the primary relays the code)
 *  - session not yet verified                                   → 'session' (full session OTP)
 *
 * @param retry callback re-run after successful verification (e.g. re-attempt the gated order).
 */
export function promptVerifyToOrder(retry?: () => void) {
  const session = useSessionStore.getState().session;
  const sessionVerified = (session?.trustLevel ?? 0) >= 2;
  const mode = sessionVerified ? 'device' : 'session';
  useVerificationStore.getState().openModal(retry, null, mode);
}
